import React from 'react';
import {useLocation} from "react-router-dom";
import finalPropsSelectorFactory from 'react-redux/es/connect/selectorFactory';
import {useQuery} from "react-query";
import {PROMOTION_VIEW_ALL} from "../../../services/common/endpoints";
import PromotionsBannner from "./PromotionsBanner";
import PromotionsContent from "./promotionsContent";

function PromotionsViewAll() {
    const location  = useLocation();
    const {
        data : {data}={},
        isLoading
    } = useQuery(["", PROMOTION_VIEW_ALL?.url, PROMOTION_VIEW_ALL?.data, {}, false],{
        retry: false,
        retryOnMount: false,
        staleTime: 0,
        cacheTime:0
    })
    const getPageComponents = (item) => {
        switch (item?.templatetype) {
        //   Banner
          case '109': {
            return <PromotionsBannner psmItem={item} bgColor={data?.bgcolor}></PromotionsBannner>;
          }
    
          // Components
          case '310': {
            return <PromotionsContent psmItem={item}></PromotionsContent>;
          }
    
          default: {
            return <></>;
          }
        }
      };
    return (
        <div className="pse_sm">
          {data?.data?.map((item, index) => {
            return <React.Fragment key={`index-${index}`}>{getPageComponents(item)}</React.Fragment>;
          })}
        </div>
    )
}

export default PromotionsViewAll
